import { DateTime } from 'luxon';
import { E_MRZ_LINE, E_TYPE_CARD } from './constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { convertToNumber } from 'src/shared/helpers/stringHelpers';
import { E_DATE_FORMAT } from 'src/shared/helpers/dateHelpers';
/**
 * An MRZ can be of 3 different types:
 *
 * Type 1 (TD1) : 30 characters on each of the 3 lines
 * Type 2 (TD2) : 36 characters on the first 2 lines and 0 for the 3rd line
 * Type 3 (TD3) : 44 characters on the first 2 lines and 0 for the 3rd line
 *
 * retrieveTypeOfCard gives which type of card is still possible
 * With the above rule if the 3rd line is filled we will be automatically in the case of a TD1
 *
 * checkValidityOfLines emits an error if the length does not match the expected one and gives details on the expected format
 */
export var retrieveTypeOfCard = function (mrzLine1, mrzLine2, mrzLine3) {
    var maxLengthLine = Math.max(mrzLine1.length, mrzLine2.length);
    if (mrzLine3.length > 0) {
        if (maxLengthLine > 30) {
            return [];
        }
        return [E_TYPE_CARD.TD1];
    }
    else if (maxLengthLine <= 30) {
        return [E_TYPE_CARD.TD1, E_TYPE_CARD.TD2, E_TYPE_CARD.TD3];
    }
    else if (maxLengthLine <= 36) {
        return [E_TYPE_CARD.TD2, E_TYPE_CARD.TD3];
    }
    else if (maxLengthLine <= 44) {
        return [E_TYPE_CARD.TD3];
    }
};
export var checkValidityOfLines = function (i18n, mrzLine1, mrzLine2, mrzLine3) {
    var _a;
    var typeOfCardAttended = retrieveTypeOfCard(mrzLine1, mrzLine2, mrzLine3);
    var couldBeTd1 = typeOfCardAttended === null || typeOfCardAttended === void 0 ? void 0 : typeOfCardAttended.includes(E_TYPE_CARD.TD1);
    var couldBeTd2 = typeOfCardAttended === null || typeOfCardAttended === void 0 ? void 0 : typeOfCardAttended.includes(E_TYPE_CARD.TD2);
    var couldBeTd3 = typeOfCardAttended === null || typeOfCardAttended === void 0 ? void 0 : typeOfCardAttended.includes(E_TYPE_CARD.TD3);
    var checkForLengthValidity = function (lineLength) {
        return mrzLine3.length > 0
            ? ![30].includes(lineLength)
            : couldBeTd1
                ? ![30, 36, 44].includes(lineLength)
                : couldBeTd2
                    ? ![36, 44].includes(lineLength)
                    : couldBeTd3
                        ? ![44].includes(lineLength)
                        : true;
    };
    var getErrorHint = function () {
        return mrzLine3.length > 0
            ? getPropsByKeyPath(i18n.modules, 'mrzChecker.error.td1')
            : couldBeTd1
                ? getPropsByKeyPath(i18n.modules, 'mrzChecker.error.general')
                : couldBeTd2
                    ? getPropsByKeyPath(i18n.modules, 'mrzChecker.error.td2td3')
                    : couldBeTd3
                        ? getPropsByKeyPath(i18n.modules, 'mrzChecker.error.td3')
                        : getPropsByKeyPath(i18n.modules, 'mrzChecker.error.general');
    };
    return _a = {},
        _a[E_MRZ_LINE.LINE_1] = {
            isError: checkForLengthValidity(mrzLine1.length),
            disabled: false,
            infoMessage: getErrorHint(),
        },
        _a[E_MRZ_LINE.LINE_2] = {
            isError: checkForLengthValidity(mrzLine2.length),
            disabled: false,
            infoMessage: getErrorHint(),
        },
        _a[E_MRZ_LINE.LINE_3] = {
            isError: (mrzLine3.length > 0 && mrzLine3.length !== 30) ||
                (mrzLine2.length === 30 && mrzLine1.length === 30 && mrzLine3.length !== 30),
            disabled: !couldBeTd1 && mrzLine3.length < 1,
            infoMessage: getPropsByKeyPath(i18n.modules, 'mrzChecker.error.td1'),
        },
        _a;
};
export var convertMRZDateDigitToDate = function (mrzDate) {
    var date = DateTime.fromObject({
        year: 1900 + convertToNumber(mrzDate === null || mrzDate === void 0 ? void 0 : mrzDate.substring(0, 2)),
        month: convertToNumber(mrzDate === null || mrzDate === void 0 ? void 0 : mrzDate.substring(2, 4)),
        day: convertToNumber(mrzDate === null || mrzDate === void 0 ? void 0 : mrzDate.substring(4, 6)),
    }).toLocaleString(E_DATE_FORMAT.DATE, { locale: 'en-US' });
    return "".concat(date.substring(0, date.length - 4)).concat(date.substring(date.length - 2));
};
